export class Aclsaveoperationlist {
    classid: number;
    permit: number;

}
